import { przezmorzePublicApi } from "../../api/publicApi";

export interface CmsComponent {
  readonly id: string;
  readonly title: string;
  readonly description: string;
  readonly buttonLabel: string;
  readonly buttonLink: string;
}

export async function getNewSeasonComponent(abortSignal?: AbortSignal): Promise<CmsComponent> {
  const response = await przezmorzePublicApi.get<CmsComponent>(`/public/cms/components/new-season`, {
    signal: abortSignal,
  });
  return response.data;
}
